module.exports = __webpack_public_path__ + "static/media/battery-bolt.c85f01dd.svg";